import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';

import { CommunityContext } from '../../../../context/ContextCreator';
import { EmitMetric } from '../../../../utils/Analytics/VisibilityPixel/VisibilityPixel';
import useUser from '../../../../utils/useUser';

const ModerationEdit = ({ hash, handleOnEditClick, closeMenu }) => {
    const { getContent } = useContext(CommunityContext);
    const { user } = useUser();
    const { isLoggedIn } = user;
    const content = getContent(hash);
    const handleEditClick = useCallback(() => {
        if (!isLoggedIn) return;
        closeMenu();
        handleOnEditClick();
        EmitMetric({
            community_content_key: `${content.type}-${hash}`,
            misc_event_count: 1,
            misc_event_type: 'edit_content_clicked',
        });
    }, [content.type, hash, isLoggedIn, handleOnEditClick, closeMenu]);
    return (
        <>
            <div
                className="component-ModerationEdit"
                onClick={handleEditClick}
                onKeyPress={handleEditClick}
                role="button"
                tabIndex={0}
            >
                <style jsx>
                    {`
                        .component-ModerationEdit {
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }
                        .component-ModerationEdit:focus {
                            outline: none;
                        }
                        .component-ModerationEdit .moderationEdit-label {
                            font-size: 14px;
                            line-height: 34px;
                            color: #353535;
                            padding-top: 2px;
                        }
                        .component-ModerationEdit svg {
                            position: relative;
                            left: 6px;
                            top: calc(50% - 9.87px / 2 + 1.06px);
                            margin-right: 13px;
                        }
                    `}
                </style>
                <span className="moderationEdit-label">Edit</span>
            </div>
        </>
    );
};

ModerationEdit.propTypes = {
    hash: PropTypes.string.isRequired,
    handleOnEditClick: PropTypes.func.isRequired,
    closeMenu: PropTypes.func,
};
ModerationEdit.defaultProps = {
    closeMenu: {},
};

ModerationEdit.displayName = 'ModerationEdit';

export default ModerationEdit;
